import { gql } from '@apollo/client';
import { TRACK_FIELDS } from './trackFields';
import { RACE_FIELDS } from './raceFields';
import { RESULT_FIELDS } from './resultFields';
import { ANALYSIS_FIELDS } from './analysisFields';

export const MEETING_FIELDS = gql`
  ${TRACK_FIELDS}
  
  fragment MeetingFields on Meeting {
    meeting_id
    meeting_date
    status
    race_count
    is_private
    is_training
    track {
      ...TrackFields
    }
    performance(analysisTypeId: $analysisTypeId) {
      top_1_win_percentage
      top_2_win_percentage
      top_3_win_percentage
      value_win_percentage
    }
    performanceImproved(analysisTypeId: $analysisTypeId) {
      meeting_id
      total_races
      top_1_picks
      top_1_scratched
      top_1_winners
      top_1_win_percentage
      top_1_places
      top_1_place_percentage
      top_1_roi
      top_2_picks
      top_2_scratched
      top_2_winners
      top_2_win_percentage
      top_2_places
      top_2_place_percentage
      top_2_roi
      top_3_picks
      top_3_scratched
      top_3_winners
      top_3_win_percentage
      top_3_places
      top_3_place_percentage
      top_3_roi
      value_picks
      value_scratched
      value_winners
      value_win_percentage
      value_places
      value_place_percentage
      value_roi
    }
    exoticBets(analysisTypeId: $analysisTypeId) {
      exactas
      exacta_percentage
      quinellas
      quinella_percentage
      trifectas
      trifecta_percentage
      box_trifectas
      box_trifecta_percentage
      first_fours
      first_four_percentage
      box_first_fours
      box_first_four_percentage
    }
    raceResultSegments(analysisTypeId: $analysisTypeId) {
      race_number
      had_winner
    }
    trackConditions {
      weather
      trackCondition
      penetrometer
      rail
      comment
      abandoned
    }
  }
`;
